import React, { FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import { Lock, Route } from "lucide-react";

const ACCESS_PASSWORD = "Dom@Belloni";

interface RoteristaPasswordGateProps {
  children: React.ReactNode;
}

const RoteristaPasswordGate: React.FC<RoteristaPasswordGateProps> = ({
  children,
}) => {
  const [unlocked, setUnlocked] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    if (password === ACCESS_PASSWORD) {
      setError("");
      setUnlocked(true);
      return;
    }
    setError("Senha incorreta");
  };

  if (unlocked) {
    return <>{children}</>;
  }

  return (
    <main className="mx-auto flex min-h-[calc(100vh-8rem)] max-w-md items-center px-4 py-10 sm:px-6">
      <div className="w-full rounded-2xl border border-neutral-200 bg-white p-6 shadow-sm sm:p-8">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10">
            <Lock className="text-primary" size={22} />
          </div>
          <h1 className="text-xl font-bold text-neutral-900">
            Roteirista manual
          </h1>
          <p className="mt-2 text-sm text-neutral-600">
            Esta tela ficou como backup. Informe a senha para liberar o acesso.
          </p>
        </div>

        <form className="space-y-4" onSubmit={handleSubmit}>
          <div>
            <label
              htmlFor="roterista-access-password"
              className="mb-1 block text-sm font-medium text-neutral-700"
            >
              Senha
            </label>
            <input
              id="roterista-access-password"
              type="password"
              autoFocus
              autoComplete="off"
              value={password}
              onChange={(event) => {
                setPassword(event.target.value);
                if (error) setError("");
              }}
              placeholder="Digite a senha"
              className={`w-full rounded-md border px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary ${
                error ? "border-error" : "border-neutral-300"
              }`}
            />
            {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
          </div>

          <button
            type="submit"
            className="w-full rounded-lg bg-primary px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary/90"
          >
            Liberar acesso
          </button>
        </form>

        <Link
          to="/roterista-automatico"
          className="mt-5 inline-flex w-full items-center justify-center gap-2 text-sm font-semibold text-neutral-600 hover:text-primary"
        >
          <Route size={16} />
          Voltar ao Roteirista automático
        </Link>
      </div>
    </main>
  );
};

export default RoteristaPasswordGate;
